import path from "ramda/src/path"
import keysIn from "ramda/src/keysIn"
import { get, post } from "../../network/endpoint"
import * as ActionTypes from "services/state/action-types"
import { CONFIG, RESET, INFORMATION_RETURN_TIMEOUT } from "./constants"
import { success, dispatchHandler } from "services/utils/action"
import { saveOperation } from "../experience/action"
import moment from "moment"

import {
  normalizeOrder,
  normalizeServiceRequest,
  normalizeIncidentOrder,
  normalizeOdinIncidentOrder,
  CREATE_COMMON_INCIDENT_ORDER_PAYLOAD,
  CREATE_ODIN_SERVICE_ORDER_PAYLOAD
} from "./helpers"
import { BFF } from "services/network/routes"

export function getRepair(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { params: payload, client: BFF }
    const request = get("servicesOrder", config)
    dispatch({
      type: ActionTypes.GET_REPAIR,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getRepairByProtocol(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { pathValues: payload, client: BFF }
    const request = get("servicesOrderByProtocol", config)
    dispatch({
      type: ActionTypes.GET_REPAIR_BY_PROTOCOL,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getServiceOrder({ requestId, system, businessUnit }, callback) {
  return (dispatch) => {
    const config = {
      pathValues: { orderId: requestId },
      params: { businessUnit, destinationSystem: system }
    }

    const request = get("servicesOrdersById", config)

    dispatch({
      type: ActionTypes.GET_SERVICE_ORDER,
      payload: request
    }).then(success(callback))
  }
}

export function changeStatus({ requestId, ...data }, callback) {
  return (dispatch) => {
    const config = { client: "sensedia", pathValues: { requestId }, data }
    const request = post("changeStatusOrderOs", config)

    return dispatch({
      type: ActionTypes.CHANGE_SOLICITATION_STATUS,
      payload: request
    }).then(success(callback))
  }
}

export function downloadRequestDetails(
  { protocol, startDate, endDate },
  callback
) {
  return (dispatch, getState) => {
    const config = {
      data: {
        startDate,
        endDate,
        ...protocol
      }
    }
    const request = post("downloadServiceOrder", config)
    let protocolId

    if (!!protocol && !!protocol.keys && protocol.keys.length > 0) {
      protocolId = protocol.keys[0]
    }

    dispatch({
      type: ActionTypes.DOWNLOAD_REQUEST_DETAIL,
      payload: request
    })
      .then((result) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            protocolId,
            "DEMAND_MONITORING",
            "DOWNLOAD",
            "SUCCESS",
            "",
            "Histórico de Solicitações"
          )
        )

        callback(result)

        window.location = result.payload.data.pathURL
      })
      .catch((error) => {
        console.error(error)
        dispatch(
          saveOperation(
            getState().customer.data,
            protocolId,
            "DEMAND_MONITORING",
            "DOWNLOAD",
            "ERROR",
            "",
            "Histórico de Solicitações"
          )
        )
      })
  }
}

export function sendMailRequestDetails(
  { email, keys, startDate, endDate, customerSegment, customerName },
  callback
) {
  return (dispatch, getState) => {
    const config = {
      data: {
        keys,
        email,
        startDate,
        endDate,
        customerSegment,
        customerName
      }
    }
    const request = post("sendServiceOrder", config)

    dispatch({
      type: ActionTypes.SEND_MAIL_REQUEST_DETAIL,
      payload: request
    })
      .then((response) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            keys[0],
            "DEMAND_MONITORING",
            "SENDBYEMAIL",
            "SUCCESS",
            "",
            "Histórico de Solicitações"
          )
        )

        callback(response)
      })
      .catch((error) => {
        console.error(error)
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "DEMAND_MONITORING",
            "SENDBYEMAIL",
            "ERROR",
            "",
            "Histórico de Solicitações"
          )
        )
      })
  }
}

export function selectProduct(product) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SELECT_INCIDENT_PRODUCT,
      payload: product
    })
  }
}

export function getProductDetail(
  { productId, agreementId, serviceId },
  callback
) {
  return (dispatch) => {
    const config = {
      pathValues: {
        productId,
        agreementId,
        serviceId
      },
      client: BFF
    }
    const request = get("productDetail", config)

    return dispatch({
      type: ActionTypes.GET_INCIDENT_PRODUCT_DETAIL,
      payload: request
    }).then(success(callback))
  }
}

export function queryOpenReason(callback) {
  return (dispatch, getState) => {
    const { productKey, contractKey } = getState().repair.wizard.product
    const config = { pathValues: { productKey, contractKey } }
    const request = get("queryOpenReason", config)

    return dispatch({
      type: ActionTypes.QUERY_OPEN_REASON,
      payload: request
    }).then(success(callback))
  }
}

export function selectReason(reason) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SELECT_INCIDENT_REASON,
      payload: reason
    })
  }
}

export function repairAutomatically(product, promise) {
  return (dispatch) => {
    dispatch(issueOrder(CONFIG, product)).then(
      success((action) => {
        const osId = path(["information", "value"], action.payload)

        const configPromise = new Promise()
        dispatch(informationReturn(osId, configPromise))

        const resetPromise = new Promise()
        configPromise.then(() => issueOrder(RESET, product))

        dispatch(informationReturn(osId, resetPromise))
        resetPromise.then(() => promise.resolve())
      })
    )
  }
}

function informationReturn(osId, promise) {
  return (dispatch) => {
    const config = { pathValues: { osId } }
    const request = get("informationReturn", config)

    return dispatch({
      type: ActionTypes.INFORMATION_RETURN,
      payload: request
    }).then(
      success((action) => {
        if (!keysIn(action.payload).length) {
          setTimeout(
            dispatch(informationReturn(osId)),
            INFORMATION_RETURN_TIMEOUT
          )
        }

        return promise.resolve(action.payload)
      })
    )
  }
}

function issueOrder(operation, product) {
  return (dispatch, getState) => {
    const config = { data: normalizeOrder(getState(), operation, product) }
    const request = post("issueOrder", config)

    return dispatch({
      type: ActionTypes.ISSUE_ORDER,
      payload: request
    })
  }
}

export function createServiceRequest() {
  return (dispatch, getState) => {
    const config = { data: normalizeServiceRequest(getState()) }
    const request = post("createServiceRequest", config)

    return dispatch({
      type: ActionTypes.CREATE_SERVICE_REQUEST,
      payload: request
    })
  }
}

export function createCommonIncident(checklist, callback, callbackFail) {
  return createIncidentOrder(
    CREATE_COMMON_INCIDENT_ORDER_PAYLOAD,
    checklist,
    callback,
    callbackFail
  )
}

export function createOdinIncident(checklist, callback, callbackFail) {
  return createIncidentOrder(
    CREATE_ODIN_SERVICE_ORDER_PAYLOAD,
    checklist,
    callback,
    callbackFail
  )
}

export function createIncidentOrder(
  payload,
  checklist,
  callback,
  callbackFail
) {
  return (dispatch, getState) => {
    const { product } = getState().repair.wizard
    const { data } = getState().customer

    const config = {
      pathValues: { productId: product.productId },
      data: normalizeIncidentOrder(payload, product, checklist)
    }

    const odinConfig = {
      client: "sensedia",
      pathValues: { productId: product.productId },
      data: normalizeOdinIncidentOrder(payload, product, checklist, data)
    }

    let request

    if (product.productSystem === "ODIN") {
      request = post("createOdinIncidentOrder", odinConfig)
      return dispatch({
        type: ActionTypes.CREATE_ODIN_INCIDENT_ORDER,
        payload: request
      }).then(
        dispatchHandler(
          (response) => {
            let status

            if (response.type === "CREATE_ODIN_INCIDENT_ORDER_FAIL") {
              status = "ERROR"
            } else {
              status = "SUCCESS"
            }
            dispatch(
              saveOperation(
                getState().customer.data,
                "",
                "INCIDENT",
                "",
                status,
                "",
                "Solicitação de incidente"
              )
            )
          },
          (error) => {
            console.error(error)
            dispatch(
              saveOperation(
                getState().customer.data,
                "",
                "INCIDENT",
                "",
                "ERROR",
                "",
                "Solicitação de incidente"
              )
            )
          }
        )
      )
    }

    request = post("incidentOrder", config)
    return dispatch({
      type: ActionTypes.CREATE_INCIDENT_ORDER,
      payload: request
    }).then(
      dispatchHandler(
        (response) => {
          let status

          if (response.type === "CREATE_INCIDENT_ORDER_FAIL") {
            status = "ERROR"
          } else {
            status = "SUCCESS"
          }
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "INCIDENT",
              "SUBMIT",
              status,
              "",
              "Solicitação de incidente"
            )
          )
        },
        (error) => {
          console.error(error)
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "INCIDENT",
              "SUBMIT",
              "ERROR",
              "",
              "Solicitação de incidente"
            )
          )
        }
      )
    )
  }
}

export function cleanWizard() {
  return (dispatch) => {
    return dispatch({
      type: ActionTypes.CLEAN_WIZARD
    })
  }
}

export function downloadDemandsFiles(demand, callback) {
  return (dispatch, getState) => {
    const protocol = demand.protocolNumber
    const customerKey = btoa(getState().customer.data.documentNumber)
    const config = { pathValues: { customerKey, protocol } }
    const request = get("audioProtocol", config)

    dispatch({
      type: ActionTypes.DOWNLOAD_DEMANDS_FILES,
      payload: request
    }).then(callback)
  }
}

export function downloadAudio(pathURL, callback) {
  return (dispatch) => {
    const request = get("downloadFileInvoice", {
      params: {
        pathURL
      },
      headers: {
        "Content-Type": "application/octet-binary"
      },
      responseType: "blob"
    })
    dispatch({
      type: ActionTypes.DOWNLOAD_AUDIO,
      payload: request
    }).then(callback)
  }
}

function getInvoiceValue(additionalInformation, callback) {
  const invoiceId = additionalInformation.invoiceId

  return (dispatch) => {
    const config = {
      pathValues: { invoiceId },
      useMock: false,
      client: BFF
    }
    const request = get("getInvoiceValue", config)

    dispatch({
      type: ActionTypes.GET_INVOICE_VALUE,
      payload: request
    }).then(
      success((response) => {
        let invoiceValue

        if (!!response && !!response.payload && !!response.payload.data) {
          invoiceValue = "R$ " + response.payload.data[0].AMOUNT
          additionalInformation = { ...additionalInformation, invoiceValue }
          return callback && callback(additionalInformation)
        }
      })
    )
  }
}

export function getInvoiceDisputingInformation(requestId, callback) {
  return (dispatch) => {
    const config = {
      pathValues: { requestId },
      useMock: false,
      client: BFF
    }
    const request = get("getInvoiceDisputingInformation", config)

    dispatch({
      type: ActionTypes.GET_INVOICE_DISPUTING_INFORMATION,
      payload: request
    })
      .then(
        success((response) => {
          let invoiceId
          let invoiceAux
          let invoiceDate
          let selectedReason
          response.payload.data.serviceRequest.fields.forEach((field) => {
            switch (field.fieldName) {
              case "INVOICE_ID":
                invoiceId = field.stringFieldValue
                break
              case "INVOICE_AUX":
                invoiceAux = field.stringFieldValue
                break
              case "INVOICE_DATE":
                invoiceDate = moment(
                  field.stringFieldValue,
                  "YYYY-MM-DD HH:mm:ss"
                ).format("DD/MM/YYYY")
                break
              case "PORTAL_ORIGIN_CATEGORY":
                selectedReason = field.stringFieldValue
                break
              default:
                break
            }
          })

          let disputingData =
            response.payload.data.serviceRequest.interaction.note
          ;[disputingData] = disputingData.substring(4).split("\n\nRemote Host")

          const additionalInformation = {
            invoiceId,
            invoiceAux,
            invoiceDate,
            selectedReason,
            disputingData
          }
          dispatch(getInvoiceValue(additionalInformation, callback))
        })
      )
      .catch((error) => {
        console.log("Error: ", error)
      })
  }
}
export function getProtocolDetails(protocolId, callback, callbackFail) {
  return (dispatch) => {
    const config = { pathValues: protocolId, client: BFF }
    const request = get("getProtocolDetails", config)
    dispatch({
      type: ActionTypes.PROTOCOL_DETAILS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function requestAudioProtocol(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { data: payload, client: BFF }
    const request = post("requestAudioProtocol", config)
    dispatch({
      type: ActionTypes.REQUEST_AUDIO_PROTOCOL,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getServiceRequestsCustomer(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { pathValues: payload, client: BFF }
    const request = get("getServiceRequestsCustomer", config)
    dispatch({
      type: ActionTypes.SERVICE_REQUESTS_CUSTOMER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/repair/action.js